import React from "react";
import { Download, ExternalLink } from "lucide-react";
import { translate } from "../utils/translateUtils";

const Brochure = () => {
  const pdfPath = "/Docs/BROCHURE GSA.pdf";
  const downloadFilename = "Brochure-Sierra-Alta-SAS.pdf";

  return (
    <section className="relative overflow-hidden bg-[#f8fafb] py-16 sm:py-20 px-4 sm:px-6 lg:px-8">

      <div className="absolute top-0 right-0 w-[420px] h-[420px] bg-[#ee7d32]/10 rounded-full blur-3xl" />
      <div className="absolute bottom-0 left-0 w-[300px] h-[300px] bg-[#ee7d32]/5 rounded-full blur-3xl" />

      <div className="relative max-w-7xl mx-auto">

        <div className="grid lg:grid-cols-[1fr_1.05fr] gap-12 xl:gap-16 items-center">

          <div className="flex flex-col justify-center">

            <div className="space-y-5">
              <h1 className="text-4xl md:text-5xl xl:text-[56px] font-bold tracking-tight text-[#111827] leading-[1.05]">
                {translate("brochureTitle", "Brochure")}
              </h1>
              <div className="w-20 h-1 rounded-full bg-[#ee7d32]" />
            </div>

            <div className="mt-7 space-y-4 text-[17px] text-[#4b5563] leading-8 max-w-xl">
              <p>
                {translate(
                  "brochureDesc",
                  "Descubre toda la información sobre nuestros productos y servicios en nuestro brochure. Aquí encontrarás detalles sobre nuestras soluciones innovadoras y cómo podemos ayudarte a alcanzar tus objetivos."
                )}
              </p>
            </div>

            <div className="mt-10 grid sm:grid-cols-2 gap-4 max-w-xl">
              <a
                href={pdfPath}
                download={downloadFilename}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 bg-[#ee7d32] hover:bg-[#d96d24] text-white px-6 py-3.5 rounded-xl font-medium transition-all duration-300 shadow-sm hover:shadow-md"
              >
                <Download size={18} stroke="White"/>
                {translate("downloadButton", "Descargar")}
              </a>

              <a
                href={pdfPath}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 bg-white border border-[#e5e7eb] text-gray-700 hover:text-[#ee7d32] hover:border-[#ee7d32] px-6 py-3.5 rounded-xl font-medium transition-all duration-300"
              >
                <ExternalLink size={18} />
                Ver Brochure
              </a>
            </div>

          </div>

          <div className="relative flex justify-center">

            <div className="absolute -inset-3 bg-[#ee7d32]/5 blur-3xl rounded-[32px]" />

            <div className="relative w-full bg-white rounded-3xl overflow-hidden border border-[#ececec] shadow-lg">

              {/* DESKTOP */}
              <div className="hidden md:block h-[650px]">
                <iframe
                  src={`${pdfPath}#view=FitH&toolbar=1`}
                  title="Brochure Sierra Alta SAS"
                  className="w-full h-full"
                  loading="lazy"
                  style={{ border: "none" }}
                />
              </div>

              {/* MOBILE */}
              <div className="md:hidden relative">

                <img
                  src="/Images/brochure/brochure.webp"
                  alt="Brochure"
                  className="w-full h-[420px] object-cover"
                />

                <div className="absolute inset-0 bg-black/50 flex flex-col items-center justify-center text-center p-6">

                  <h3 className="text-2xl font-bold text-white">
                    Brochure
                  </h3>

                  <p className="text-white/80 text-sm mt-2">
                    Consulta nuestro brochure completo
                  </p>

                  <a
                    href={pdfPath}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-6 bg-[#ee7d32] hover:bg-[#d96d24] text-white px-6 py-3 rounded-xl font-medium transition"
                  >
                    Abrir Brochure
                  </a>

                </div>

              </div>

            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Brochure;